import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/hooks/useSeo";
import { api } from "@/lib/api";
import { BookingModal } from "@/components/BookingModal";
import { shareWhatsApp } from "@/lib/whatsapp";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function Offers() {
  const { t, lang, money } = useApp();
  useSeo({ title: t.seo.offers[0], description: t.seo.offers[1] });
  const [offers, setOffers] = useState([]);
  const [booking, setBooking] = useState(null);
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)); }, []);

  const shareOffer = (o) => {
    const msg = lang === "ar"
      ? `🔥 ${o.title_ar}\n${o.desc_ar}\n💰 ${money(o.price)} بدلاً من ${money(o.old_price)}\nسفير بغداد`
      : `🔥 ${o.title_en}\n${o.desc_en}\n💰 ${money(o.price)} instead of ${money(o.old_price)}\nSafeer Baghdad`;
    shareWhatsApp(msg);
  };

  return (
    <div className="bg-sand min-h-screen">
      <div className="bg-tigris py-14 px-4 sm:px-6 text-center">
        <h1 className="text-white text-3xl sm:text-4xl font-bold font-display mb-3">{t.sections.offersTitle}</h1>
        <p className="text-white/80 max-w-2xl mx-auto">{t.sections.offersSub}</p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {offers.map((o, i) => (
          <motion.div key={o.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            data-testid={`offers-page-card-${o.id}`}
            className="bg-white rounded-2xl overflow-hidden card-hover flex flex-col shadow-sm border border-slate-100">
            <div className="relative h-48">
              <img src={o.image} alt={o[`title_${lang}`]} className="w-full h-full object-cover" />
              <span className="absolute top-3 start-3 text-white text-xs font-bold px-3 py-1 rounded-full" style={{ background: "var(--clay)" }}>{o[`badge_${lang}`]}</span>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <h3 className="font-bold text-lg text-slate-800 mb-1.5">{o[`title_${lang}`]}</h3>
              <p className="text-sm text-slate-500 line-clamp-2 mb-4 flex-1">{o[`desc_${lang}`]}</p>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl font-extrabold text-tigris">{money(o.price)}</span>
                <span className="text-sm text-slate-400 line-through">{money(o.old_price)}</span>
              </div>
              <div className="flex gap-2">
                <button data-testid={`offers-page-book-${o.id}`} onClick={() => setBooking({ type: "package", item_id: o.ref_package, title: o[`title_${lang}`], amount: o.price, details: { offer_id: o.id } })}
                  className="btn-gold flex-1 py-2.5 rounded-xl font-bold text-sm">{t.common.bookNow}</button>
                <button data-testid={`offers-page-share-${o.id}`} onClick={() => shareOffer(o)} className="btn-wa w-11 rounded-xl flex items-center justify-center">
                  <MessageCircle size={18} />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      {booking && <BookingModal item={booking} onClose={() => setBooking(null)} />}
    </div>
  );
}
